// AUTO-GENERATED FILE - DO NOT EDIT
// Generated by scripts/generate-cube-meta.ts
import type {
  CubeMeasureEntry,
  CubeDimensionEntry,
  CubeJoinEntry
} from 'shared/src/api/cube-api-types';

export const zohoLineItemsCubeMeta = {
  name: 'zoho_line_items',
  sqlTable: 'media_tool.zoho_line_items',
  title: 'Zoho Line Items',
  joins: {
    insertion_orders: { relationship: 'many_to_one' } as const satisfies CubeJoinEntry,
    campaigns: { relationship: 'many_to_one' } as const satisfies CubeJoinEntry
  },
  measures: {
    'zoho_line_items.count': {
      type: 'number',
      aggType: 'count',
      title: 'Line Item Count',
      description: 'Number of Zoho line items',
      meta: {
        category: 'utility',
        supports_rollup: true,
        formula: 'COUNT(*)',
        inputs: [],
        short_description: 'Number of Zoho line items',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeMeasureEntry
  },
  dimensions: {
    'zoho_line_items.id': {
      sql: 'id',
      type: 'string',
      title: 'Line Item ID',
      primaryKey: true,
      meta: {
        short_description: 'Zoho CRM Line Item ID',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.name': {
      sql: 'name',
      type: 'string',
      title: 'Line Item Name',
      meta: {
        short_description: 'Line item display name',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.gross_budget': {
      sql: "CAST(NULLIF(NULLIF(zoho_line_items.gross_budget, ''), 'N/A') AS numeric)",
      type: 'number',
      title: 'Gross Budget',
      format: 'currency',
      meta: {
        category: 'financial',
        short_description: 'Gross budget amount (cast from text)',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.price': {
      sql: "CAST(NULLIF(NULLIF(zoho_line_items.price, ''), 'N/A') AS numeric)",
      type: 'number',
      title: 'Price',
      format: 'currency',
      meta: {
        category: 'financial',
        short_description: 'Line item price (cast from text)',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.mgmt_fee': {
      sql: "CAST(NULLIF(NULLIF(zoho_line_items.mgmt_fee, ''), 'N/A') AS numeric)",
      type: 'number',
      title: 'Management Fee',
      format: 'currency',
      meta: {
        category: 'financial',
        short_description: 'Management fee amount (cast from text)',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.media_budget': {
      sql: "CAST(NULLIF(NULLIF(zoho_line_items.media_budget, ''), 'N/A') AS numeric)",
      type: 'number',
      title: 'Media Budget',
      format: 'currency',
      meta: {
        category: 'financial',
        short_description: 'Media budget amount (cast from text)',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.unit_price': {
      sql: "CAST(NULLIF(NULLIF(zoho_line_items.unit_price, ''), 'N/A') AS numeric)",
      type: 'number',
      title: 'Unit Price',
      format: 'currency',
      meta: {
        category: 'financial',
        short_description: 'Unit price amount (cast from text)',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.referral_fee': {
      sql: "CAST(NULLIF(NULLIF(zoho_line_items.referral_fee, ''), 'N/A') AS numeric)",
      type: 'number',
      title: 'Referral Fee',
      format: 'currency',
      meta: {
        category: 'financial',
        short_description: 'Referral fee amount (cast from text)',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.gross_unit_price': {
      sql: "CAST(NULLIF(NULLIF(zoho_line_items.gross_unit_price, ''), 'N/A') AS numeric)",
      type: 'number',
      title: 'Gross Unit Price',
      format: 'currency',
      meta: {
        category: 'financial',
        short_description: 'Gross unit price (cast from text)',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.media_unit_price': {
      sql: "CAST(NULLIF(NULLIF(zoho_line_items.media_unit_price, ''), 'N/A') AS numeric)",
      type: 'number',
      title: 'Media Unit Price',
      format: 'currency',
      meta: {
        category: 'financial',
        short_description: 'Media unit price (cast from text)',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.display_unit_price': {
      sql: "CAST(NULLIF(NULLIF(zoho_line_items.display_unit_price, ''), 'N/A') AS numeric)",
      type: 'number',
      title: 'Display Unit Price',
      format: 'currency',
      meta: {
        category: 'financial',
        short_description: 'Display unit price (cast from text)',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.start_date': {
      sql: 'start_date',
      type: 'time',
      title: 'Start Date',
      meta: {
        short_description: 'Line item start date',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.end_date': {
      sql: 'end_date',
      type: 'time',
      title: 'End Date',
      meta: {
        short_description: 'Line item end date',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.channel': {
      sql: 'channel',
      type: 'string',
      title: 'Channel',
      meta: {
        short_description: 'Media channel for the line item',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.line_item_status': {
      sql: 'line_item_status',
      type: 'string',
      title: 'Line Item Status',
      meta: {
        short_description: 'Current status of the line item',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.bravo_line_item_id': {
      sql: 'bravo_line_item_id',
      type: 'string',
      title: 'Bravo Line Item ID',
      meta: {
        short_description: 'Linked Bravo line item identifier',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.bravo_media_strategy_id': {
      sql: 'bravo_media_strategy_id',
      type: 'string',
      title: 'Bravo Media Strategy ID',
      meta: {
        short_description: 'Linked Bravo media strategy identifier',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.related_insertion_order': {
      sql: 'related_insertion_order',
      type: 'string',
      title: 'Related Insertion Order',
      meta: {
        short_description: 'Associated insertion order ID',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.media_campaign': {
      sql: 'media_campaign',
      type: 'string',
      title: 'Media Campaign',
      meta: {
        short_description: 'Associated campaign/deal ID',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.tactics': {
      sql: 'tactics',
      type: 'string',
      title: 'Tactics',
      meta: {
        short_description: 'Media tactics for the line item',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.ad_size': {
      sql: 'ad_size',
      type: 'string',
      title: 'Ad Size',
      meta: {
        short_description: 'Ad size specification',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.geo': {
      sql: 'geo',
      type: 'string',
      title: 'Geo',
      meta: {
        short_description: 'Geographic targeting',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.audience': {
      sql: 'audience',
      type: 'string',
      title: 'Audience',
      meta: {
        short_description: 'Target audience',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.modified_time': {
      sql: 'modified_time',
      type: 'time',
      title: 'Modified Time',
      meta: {
        short_description: 'Last modified timestamp from Zoho CRM',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.is_linked_to_bravo': {
      sql: "zoho_line_items.bravo_line_item_id IS NOT NULL AND zoho_line_items.bravo_line_item_id ~ '^[0-9a-f]{8}-'",
      type: 'boolean',
      title: 'Linked to Bravo',
      meta: {
        short_description: 'Whether this Zoho line item is linked to a valid Bravo line item',
        source_tables: ['media_tool.zoho_line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.bravo_price': {
      sql: "(SELECT bli.price FROM execution.line_items bli WHERE NOT bli.is_deleted AND bli.id = CASE WHEN zoho_line_items.bravo_line_item_id ~ '^[0-9a-f]{8}-' THEN zoho_line_items.bravo_line_item_id::uuid END)",
      type: 'number',
      title: 'Bravo Price',
      format: 'currency',
      meta: {
        short_description: 'Price of the linked Bravo line item (NULL if unlinked)',
        source_tables: ['media_tool.zoho_line_items', 'execution.line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.price_difference': {
      sql: "CAST(NULLIF(NULLIF(zoho_line_items.price, ''), 'N/A') AS numeric) - (SELECT bli.price FROM execution.line_items bli WHERE NOT bli.is_deleted AND bli.id = CASE WHEN zoho_line_items.bravo_line_item_id ~ '^[0-9a-f]{8}-' THEN zoho_line_items.bravo_line_item_id::uuid END)",
      type: 'number',
      title: 'Price Difference (Zoho - Bravo)',
      format: 'currency',
      meta: {
        short_description: 'Zoho price minus Bravo price. Non-zero indicates a discrepancy.',
        source_tables: ['media_tool.zoho_line_items', 'execution.line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.start_date_matches': {
      sql: "zoho_line_items.start_date::date IS NOT DISTINCT FROM (SELECT bli.start_date FROM execution.line_items bli WHERE NOT bli.is_deleted AND bli.id = CASE WHEN zoho_line_items.bravo_line_item_id ~ '^[0-9a-f]{8}-' THEN zoho_line_items.bravo_line_item_id::uuid END)",
      type: 'boolean',
      title: 'Start Date Matches Bravo',
      meta: {
        short_description: 'Whether Zoho and Bravo start dates match',
        source_tables: ['media_tool.zoho_line_items', 'execution.line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.end_date_matches': {
      sql: "zoho_line_items.end_date::date IS NOT DISTINCT FROM (SELECT bli.end_date FROM execution.line_items bli WHERE NOT bli.is_deleted AND bli.id = CASE WHEN zoho_line_items.bravo_line_item_id ~ '^[0-9a-f]{8}-' THEN zoho_line_items.bravo_line_item_id::uuid END)",
      type: 'boolean',
      title: 'End Date Matches Bravo',
      meta: {
        short_description: 'Whether Zoho and Bravo end dates match',
        source_tables: ['media_tool.zoho_line_items', 'execution.line_items']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_line_items.has_discrepancy': {
      sql: "( CAST(NULLIF(NULLIF(zoho_line_items.price, ''), 'N/A') AS numeric) <> (SELECT bli.price FROM execution.line_items bli WHERE NOT bli.is_deleted AND bli.id = CASE WHEN zoho_line_items.bravo_line_item_id ~ '^[0-9a-f]{8}-' THEN zoho_line_items.bravo_line_item_id::uuid END) OR zoho_line_items.start_date::date IS DISTINCT FROM (SELECT bli.start_date FROM execution.line_items bli WHERE NOT bli.is_deleted AND bli.id = CASE WHEN zoho_line_items.bravo_line_item_id ~ '^[0-9a-f]{8}-' THEN zoho_line_items.bravo_line_item_id::uuid END) OR zoho_line_items.end_date::date IS DISTINCT FROM (SELECT bli.end_date FROM execution.line_items bli WHERE NOT bli.is_deleted AND bli.id = CASE WHEN zoho_line_items.bravo_line_item_id ~ '^[0-9a-f]{8}-' THEN zoho_line_items.bravo_line_item_id::uuid END) )",
      type: 'boolean',
      title: 'Has Discrepancy',
      meta: {
        short_description:
          'True when price, start date, or end date differs between Zoho and Bravo',
        source_tables: ['media_tool.zoho_line_items', 'execution.line_items']
      }
    } as const satisfies CubeDimensionEntry
  }
};
